export const PAGE_TITLES = {
  // Auth
  signIn: "Sign In",
  createAccount: "Create Account",
  resetPassword: "Reset Password",
  createNewPassword: "Create New Password",
  unlockAccount: "Unlock Account",
  twoFactorAuthentication: "Two-Factor Authentication",
  activateAccount: "Activate Account",
  demoLogin: "Demo Login",
  selectTeam: "Select Team",
  setUpPlatform: "Set Up Your Platform",
  platformBeingBuilt: "Your Platform Is Being Built",
  // The Autopto offers after the first card.
  autoptoUpsell: "48 Hour Launch",
  autoptoDownsell: "7 Day Springboard",

  dashboard: "Dashboard",
  addSite: "Add Site",

  // Site pages
  analytics: "Analytics",
  pages: "Pages",
  onPage: "OnPage",
  keywords: "Keywords",
  keywordsList: "Keywords List",
  keywordImports: "Keyword Imports",
  interlinks: "Interlink Automations",
  siteSettings: "Site Settings",
  googleDashboard: "Google Dashboard",
  linkOverview: "Link Overview",
  authorityLinks: "Authority Links",
  foundationLinks: "Foundation Links",
  communityLinks: "Community Links",
  trafficMetrics: "Traffic Metrics",
  visibilityMetrics: "Visibility Metrics",
  content: "Content",
  schema: "Schema",
  aiInstructions: "AI Instructions",
  liveEditor: "Live Editor",
  installLiveEditor: "Install Live Editor",

  // Reports
  workDoneReports: "Work Done Reports",
  builtLinksReports: "Built Links Reports",
  keywordRankingReports: "Keyword Ranking Reports",
  siteSalesReports: "Site Sales Reports",
  recommendationExports: "Recommendation Exports",
  clientReports: "Client Reports",

  // AI Visibility Engine
  aiVisibilityEngine: "AI Visibility Engine",
  aboutAiVisibilityEngine: "About AI Visibility Engine",
  domains: "Domains",

  // Account and team
  settings: "Settings",
  teamMembers: "Team Members",
  apiKeys: "API Keys",

  // Billing
  currentPlan: "Current Plan",
  subscribe: "Subscribe",
  subscriptionPlans: "Subscription Plans",
  invoices: "Invoices",

  // Done-for-you services
  services: "Services",
  pastOrders: "Past Orders",
  authorityService: "Done-for-You Authority Service",
  foundationService: "Done-for-You Foundation Service",
  communityLinksService: "Done-for-You Community Links",
  conciergeService: "Done-for-You Concierge Setup",
  llmCitationsService: "Done-for-You LLM Citations",
} as const;
